import { useStore } from '@/store/zustand-solicitud';
import { hashSha256 } from './security';
import { setCrypto } from './cookies';

export const cortarArrayHastaUrl = async (data, url) => {
	const index = data.findIndex((item) => item.url === url);

	// Si no se encuentra la URL, devolver el array completo
	if (index === -1) {
		return data;
	}

	data = data.slice(index);
	let newData = await Promise.all(
		data.map(async (step) => ({
			...step,
			hash: await hashSha256(process.env.NEXT_PUBLIC_HASH_KEY + step.url),
		}))
	);

	// useStore.setState({ setSteps: data});

	// Cortar el array desde el índice encontrado hasta el final
	return data;
};
